import cn from 'classnames'
import {FC} from 'react'

import {CHECKBOX_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'

type CheckboxMarkProps = {
  isChecked: boolean
  isDisabled?: boolean
  hasError?: boolean
}

export const CheckboxMark: FC<React.PropsWithChildren<CheckboxMarkProps>> = ({
  isChecked,
  isDisabled = false,
  hasError,
}) => {
  return (
    <>
      <span
        className={cn(
          'mark',
          isChecked && 'checked',
          isDisabled && 'disabled',
          hasError && 'error',
        )}
      />

      <style jsx>{`
        .mark {
          display: block;
          height: 20px;
          width: 20px;
          flex: 0 0 20px;
          background-color: ${theme.palette.background.default};
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]};
          border-radius: 4px;
          transition: background-color ${CHECKBOX_TRANSITION}ms ease-in-out;
        }
        .mark::after {
          content: '';
          width: 100%;
          height: 100%;
          background-image: url('/images/icons/checkmark.svg');
          background-size: 16px;
          background-repeat: no-repeat;
          background-position: center;
          display: none;
        }
        .mark:not(.checked, .disabled):hover {
          background-color: ${theme.palette.gray[50]};
        }
        .checked {
          background-color: ${theme.palette.gray[900]};
          box-shadow: none;
        }
        .checked::after {
          display: block;
        }
        .disabled:not(.checked) {
          background-color: ${theme.palette.gray[100]};
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[200]};
        }
        .disabled {
          background-color: ${theme.palette.gray[400]};
        }
        .error {
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.red[700]};
        }
      `}</style>
      <style jsx global>{`
        input:focus + .checkbox .mark {
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]},
            0px 0px 0px 4px ${theme.palette.gray[100]};
        }
        input:focus + .checkbox .checked {
          box-shadow: 0px 0px 0px 4px ${theme.palette.gray[100]};
        }
      `}</style>
    </>
  )
}
